import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { IAdminUser, IAdminInvitePayload, IAdminUpdatePayload } from "../../../types/api/adminUser";

export const listAdminUsers = (): Promise<AxiosResponse<TResponse<IAdminUser[]>>> =>
  axios.get(API_ENDPOINTS.ADMIN_USER_LIST);

export const inviteAdmin = (data: IAdminInvitePayload): Promise<AxiosResponse<TResponse<IAdminUser>>> =>
  axios.post(API_ENDPOINTS.ADMIN_USER_INVITE, data);

export const updateAdmin = (data: IAdminUpdatePayload): Promise<AxiosResponse<TResponse<IAdminUser>>> =>
  axios.put(`${API_ENDPOINTS.ADMIN_USER_UPDATE}/${data.id}`, data);

export const deactivateAdmin = (id: number): Promise<AxiosResponse<TResponse<null>>> =>
  axios.delete(`${API_ENDPOINTS.ADMIN_USER_DELETE}/${id}`);
